import React from "react";
import { Box, Typography, Button, Chip, Tabs, Tab } from "@mui/material";
import { TRAIT_CATEGORIES } from "../../../utilities/aiMatchmaker";
import ConfidenceLegend from "./ConfidenceLegend";

const dotColor = (c) => {
  if (c >= 0.75) return "#2e9b5b";
  if (c >= 0.5) return "#e0952f";
  return "#b0b0b0";
};

const groupByCategory = (list) =>
  TRAIT_CATEGORIES.map((cat) => ({
    ...cat,
    items: list.filter((t) => t.category === cat.key),
  })).filter((g) => g.items.length > 0);

const Review = ({ traits, onDelete, onBack, initialTab }) => {
  const [tab, setTab] = React.useState(initialTab || "me");

  const isMe = tab === "me";
  const list = isMe ? traits.self : traits.partner;
  const promptType = isMe ? "self_perception" : "partner_preference";
  const groups = groupByCategory(list);

  return (
    <Box sx={{ p: 2.5, pb: 12, maxWidth: 560, mx: "auto" }}>
      <Typography
        onClick={onBack}
        sx={{
          fontSize: 14,
          fontWeight: 600,
          color: "primary.main",
          cursor: "pointer",
          mb: 2,
        }}
      >
        {"‹ Matchmaker"}
      </Typography>

      <Typography sx={{ fontSize: 22, fontWeight: 700, mb: 0.5 }}>
        Review your traits
      </Typography>
      <Typography sx={{ fontSize: 13, color: "text.secondary", mb: 2 }}>
        Remove anything that doesn't sound like you. To add more, record a new
        note.
      </Typography>

      <Tabs
        value={tab}
        onChange={(e, next) => setTab(next)}
        variant="fullWidth"
        sx={{ mb: 2.5, borderBottom: 1, borderColor: "divider" }}
      >
        <Tab value="me" label="About you" />
        <Tab value="look" label="Looking for" />
      </Tabs>

      <ConfidenceLegend sx={{ mb: 2.5 }} />

      {groups.length === 0 ? (
        <Typography sx={{ fontSize: 14, color: "text.secondary", py: 4, textAlign: "center" }}>
          Nothing here yet. Record a note to fill this in.
        </Typography>
      ) : (
        groups.map((group) => (
          <Box key={group.key} sx={{ mb: 2.5 }}>
            <Typography
              sx={{
                fontSize: 12,
                fontWeight: 700,
                textTransform: "uppercase",
                letterSpacing: 0.5,
                color: "text.secondary",
                mb: 1,
              }}
            >
              {group.label}
            </Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
              {group.items.map((t) => (
                <Chip
                  key={t.id}
                  label={t.value}
                  onDelete={() => onDelete(promptType, t.id)}
                  icon={
                    <Box
                      sx={{
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        bgcolor: dotColor(t.confidence),
                        ml: 1,
                      }}
                    />
                  }
                  sx={{ fontSize: 13 }}
                />
              ))}
            </Box>
          </Box>
        ))
      )}

      <Button
        className="tnfm-pill-btn"
        variant="outlined"
        fullWidth
        onClick={onBack}
        sx={{ mt: 2 }}
      >
        Done
      </Button>
    </Box>
  );
};

export default Review;
